import React, { useState } from "react";
import i18n from "i18next";

/* eslint-disable react/prop-types */

const IDLE = "idle";
const ANSWERED = "answered";

export default function TrueFalseElement({ element, onActions }) {
  const [phase, setPhase] = useState(IDLE);
  const [wasCorrect, setWasCorrect] = useState(null);

  const {
    question = "",
    image,
    correctAnswer = true,
    trueLabel = i18n.t("InteractiveScenario.Option.True") || "Doğru",
    falseLabel = i18n.t("InteractiveScenario.Option.False") || "Yanlış",
    correctActions = [],
    incorrectActions = [],
    explanation = "",
  } = element;

  const handleAnswer = (answer) => {
    if (phase === ANSWERED) return;
    const correct = answer === correctAnswer;
    setWasCorrect(correct);
    setPhase(ANSWERED);

    // Fire actions after a short delay so the user can see the feedback
    const actions = correct ? correctActions : incorrectActions;
    if (actions.length > 0) {
      setTimeout(() => onActions(actions), 1200);
    }
  };

  return (
    <div className="sce-truefalse">
      {image && (
        <div className="sce-truefalse__img-wrap">
          <img src={image} alt="" className="sce-truefalse__img" />
        </div>
      )}

      <p className="sce-truefalse__question">{question}</p>

      <div className="sce-truefalse__choices">
        <button
          type="button"
          disabled={phase === ANSWERED}
          className={`sce-btn sce-truefalse__btn sce-truefalse__btn--true${
            phase === ANSWERED
              ? correctAnswer === true
                ? " sce-truefalse__btn--correct"
                : " sce-truefalse__btn--wrong"
              : ""
          }`}
          onClick={() => handleAnswer(true)}
        >
          {trueLabel}
        </button>
        <button
          type="button"
          disabled={phase === ANSWERED}
          className={`sce-btn sce-truefalse__btn sce-truefalse__btn--false${
            phase === ANSWERED
              ? correctAnswer === false
                ? " sce-truefalse__btn--correct"
                : " sce-truefalse__btn--wrong"
              : ""
          }`}
          onClick={() => handleAnswer(false)}
        >
          {falseLabel}
        </button>
      </div>

      {phase === ANSWERED && (
        <div
          className={`sce-truefalse__feedback sce-truefalse__feedback--${wasCorrect ? "correct" : "wrong"}`}
        >
          <span className="sce-truefalse__feedback-icon">{wasCorrect ? "✓" : "✗"}</span>
          {explanation && <p className="sce-truefalse__explanation">{explanation}</p>}
        </div>
      )}
    </div>
  );
}
